import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import { type AuthAdmin, type AuthErrorResponse } from '../types/auth.types'

// get admin status, it is exist or not, that shows us it is logged in or not
export const getAdminStatus = createAsyncThunk<
AuthAdmin | AuthErrorResponse,
void,
{ rejectValue: AuthErrorResponse }
>('auth/getAdminStatus', async (_, { rejectWithValue }) => {
  try {
    const admin = await axios.get<AuthAdmin>(
     `${process.env.REACT_APP_API_URL}/api/authadmin/status`,
      {
        headers:{
          Authorization:`Bearer ${localStorage.getItem('@jwt-token')}`
        }
      }
    )

    return admin.data
  } catch (error: any) {
    return rejectWithValue(error)
  }
})

// logout
export const logout = createAsyncThunk<
{ logout: boolean },
void,
{ rejectValue: AuthErrorResponse }
>('auth/logut', async (_, { rejectWithValue }) => {
  try {
    localStorage.removeItem('@jwt-token');
    return {logout: true}
  } catch (error: any) {
    return rejectWithValue(error)
  }
})
